export default __webpack_public_path__ + "static/media/early_prototype4.3bf51cc4.jpeg";